import ReactController from '~/controllers/react_controller'
import AWSEC2DashboardCharts from '~/dashboard/aws_ec2_dashboard_charts'

export default class AWSEC2DashboardChartsController extends ReactController {
  static values = {
    organizationId: String,
    isAdmin: Boolean,
  }

  createComponent() {
    return <AWSEC2DashboardCharts organizationId={this.organizationIdValue} isAdmin={this.isAdminValue} />
  }
}
